import { render, staticRenderFns } from "./SearchResultSuggestedCategories.vue?vue&type=template&id=6ec8dcf4&"
import script from "./SearchResultSuggestedCategories.vue?vue&type=script&lang=ts&"
export * from "./SearchResultSuggestedCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports